<template>
  <Label :class="classes" :text="String(text)" textWrap />
</template>

<script>

export default {
  props: {
    text: {},
    dark: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    },
    sub: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'caption': true,
        'sub': this.sub,
        'dark': this.dark,
        'center': this.center,
        'left': this.left,
        'right': this.right,
        'no-margin': this.noMargin
      }
    }
  }
}

</script>

<style scoped lang="scss">

.caption {
  font-family: 'Inter', 'RobotoCondensed', 'Roboto Condensed';
  font-weight: 600;
  color: #3b3b3b;
  text-align: center;

  &.dark {
    color: white;
  }

  &.center {
    text-align: center;
  }

  &.left {
    text-align: left;
  }

  &.right {
    text-align: right;
  }
}

.ns-ios,
.ns-android {
  .caption {
    font-size: 22;
    margin-top: 50;

    &.no-margin {
      margin-top: 0;
    }

    &.sub {
      padding-top: 20;
      font-size: 18;
    }
  }
}

.ns-ios .caption {
  font-size: 25;
}

html {
  .caption {
    font-size: 32px;
    margin-top: 50px;

    &.no-margin {
      margin-top: 0;
    }
    
    &.sub {
      padding-top: 20px;
      font-size: 18px;
    }
  }
}

</style>
